<template>
	<div class="container">
		<header class="header">
			<router-link :to="{ name: 'Search', params: { lang: $route.params.lang } }" class="title">
				<i class="fa fa-chevron-left" aria-hidden="true"></i>
				{{ $t("backBtn") }}
			</router-link>
			<div class="lang">
				<router-link class="lang__item" :class="{ active: $route.params.lang === 'uz' }"
					:to="{ name: 'Booking', params: { lang: 'uz' } }">
					<img class="img" :src="linkImg + '/img/041-uzbekistan.png'" alt="" />
				</router-link>
				<router-link class="lang__item" :class="{ active: $route.params.lang === 'ru' }"
					:to="{ name: 'Booking', params: { lang: 'ru' } }">
					<img class="img" :src="linkImg + '/img/044-russia.png'" alt="" />
				</router-link>
				<router-link class="lang__item" :class="{ active: $route.params.lang === 'en' }"
					:to="{ name: 'Booking', params: { lang: 'en' } }">
					<img class="img" :src="linkImg + '/img/186-united-states.png'" alt="" />
				</router-link>
			</div>
		</header>
		<h1 class="title-br">{{ $t("booking") }}</h1>
		<section class="booking-title">
			<h2>{{ filial.BranchName }}</h2>
			<p>{{ filial.BranchAddress }}</p>
		</section>

		<form class="card" @submit.prevent="handleSubmit" method="post">

			<div v-if="authStep === 1">
				<div class="card__item">
					<p>{{ $t("personalInformation") }}</p>
					<input class="input name" :class="$v.bookingInfo.name.$error ? 'is-invalid' : ''" type="text"
						:placeholder="$t('name') + '*'" v-model.trim="$v.bookingInfo.name.$model" />
					<input class="input surname " :class="$v.bookingInfo.surname.$error ? 'is-invalid' : ''" type="text"
						:placeholder="$t('surname') + '*'" v-model.trim="$v.bookingInfo.surname.$model" />
					<input class="input phone " :class="$v.bookingInfo.phone.$error ? 'is-invalid' : ''" type="tel"
						placeholder="+998" v-model.trim="$v.bookingInfo.phone.$model" />
				</div>

				<div class="card__item">
					<p>{{ $t("bookingData") }}</p>
					<div class="input modal-input" :class="$v.bookingInfo.serviseText.$error ? 'is-invalid' : ''"
						@click="openService()">
						<h1 class="modal-input__title">{{ $t("service") }}*</h1>
						<div class="modal-input__service">
							<p>{{ bookingInfo.serviseText }}</p>
							<i class="fa fa-caret-down" aria-hidden="true"></i>
						</div>
					</div>

					<div class="posRel">
						<div v-show="isInputActiveDate" class="inputBlock"></div>
						<div class="date-input">
							<h1 class="date-input__title" :class="$v.date.$error && !$v.date.required ? 'is-invalid' : ''">
								{{ $t("date") }}*
							</h1>
							<datepicker
								:input-class="$v.date.$error && !$v.date.required ? 'date-input__class-date is-invalid' : 'date-input__class-date'"
								calendar-class="date-calendar" :language="$t('local') === 'en' ? en : $t('local') === 'ru' ? ru : uz"
								:disabled-dates="disabledDates" :format="customFormatter" v-model.trim="$v.date.$model" monday-first>
							</datepicker>
							<i class="fa fa-caret-down" aria-hidden="true"
								:class="$v.date.$error && !$v.date.required ? 'is-invalid' : ''"></i>
						</div>
					</div>

					<div class="posRel">
						<div v-show="isInputActiveTime" class="inputBlock"></div>
						<div class="input modal-input" :class="$v.bookingInfo.time.$error ? 'is-invalid' : ''" @click="openTime()">
							<h1 class="modal-input__title">{{ $t("time") }}*</h1>
							<div class="modal-input__service">
								<p>{{ bookingInfo.time }}</p>
								<i class="fa fa-caret-down" aria-hidden="true"></i>
							</div>
						</div>
					</div>
				</div>
				<button class="btn w-100" type="submit">{{ $t("getSmsCode") }}</button>
			</div>

			<div v-if="authStep === 2" class="card__item">
				<p style=" font-family: 'Roboto';text-align: center; margin-bottom: 15px;">{{ $t("smsSentTo") }} {{
					bookingInfo.phone }}</p>
				<input class="input" style=" font-family: 'Roboto';text-align: center; font-size: 24px; letter-spacing: 6px;"
					type="tel" v-model="otpCode" placeholder="0000" maxlength="4" />

				<button class="btn" type="submit" style="margin-top: 20px;">{{ $t("confirmAndBook") }}</button>
				<a @click.prevent="authStep = 1"
					style="display: block; font-family: 'Roboto'; text-align: center; margin-top: 15px; cursor: pointer; color: #7d8533; padding: 12px;">
					{{ $t("changePhone") }}
				</a>
			</div>

			<div v-show="isActive" class="modal-inputSelect">
				<div class="modal-inputSelect__title">
					<h2>{{ $t("service") }}*</h2>
					<a href="/" class="close-link" @click.prevent="closeService()">
						<i class="fa fa-times" aria-hidden="true"></i>
					</a>
				</div>
				<ul>
					<li v-for="item in items" :key="item.ServiceId" class="item"
						:class="{ activeItem: liActive === item.ServiceId }" @click="liServiceActiveLink(item.ServiceId)">
						<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
						<p>{{ item.ServiceName }}</p>
					</li>
				</ul>
				<div class="modal-btn">
					<a href="" class="modal-btn__link" @click.prevent="showService()">{{ $t("choose") }}</a>
				</div>
			</div>
			<div v-show="isActive" class="modal-inputSelectBg"></div>

			<div v-show="isTimeActive" class="modal-inputSelect">
				<div class="modal-inputSelect__title">
					<h2>{{ $t("time") }}*</h2>
					<a href="/" class="close-link" @click.prevent="closeTime()">
						<i class="fa fa-times" aria-hidden="true"></i>
					</a>
				</div>
				<ul>
					<li v-for="ite in timeAll" :key="ite.index" class="item" :class="{
						activeItem: liTimeActive === ite.Time,
						deactive: ite.IsAvailableTime === false
					}" @click="liTimeActiveLink(ite)">
						<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
						<p>{{ ite.Time }}</p>
					</li>
				</ul>
				<div class="modal-btn">
					<a href="" class="modal-btn__link" @click.prevent="showTime()">{{ $t("choose") }}</a>
				</div>
			</div>
			<div v-show="isTimeActive" class="modal-inputSelectBg"></div>
		</form>

		<div v-show="cardModal" class="card-modal">
			<a href="" class="close-link" @click.prevent="close()">
				<i class="fa fa-times" aria-hidden="true"></i>
			</a>
			<h1>{{ $t("initialData") }}</h1>
			<p>{{ $t("name") }}: {{ bookingInfo.name }}</p>
			<p>{{ $t("surname") }}: {{ bookingInfo.surname }}</p>
			<p>{{ $t("phone") }}: {{ bookingInfo.phone }}</p>
			<h2>{{ $t("bookingDetails") }}</h2>
			<p>{{ $t("service") }}: {{ bookingInfo.serviseText }}</p>
			<p>{{ $t("date") }}: {{ bookingInfo.date.month }} {{ bookingInfo.date.day }}, {{ bookingInfo.date.year }}</p>
			<p>{{ $t("time") }}: {{ bookingInfo.time }}</p>
			<button class="btn" @click="send()">{{ $t("bookADate") }}</button>
		</div>
		<div v-show="cardModalBg" class="modal_bg"></div>

		<div v-show="cardModalEnd" class="card-modal-end">
			<div class="card-modal-end__info">
				<a href="/" class="close-link" @click.prevent="closeEnd()">
					<i class="fa fa-times" aria-hidden="true"></i>
				</a>
				<h1>{{ $t("successfulBooking") }}</h1>
				<div class="kod">
					<span class="kod__title">{{ $t("bookingCode") }}</span>
					<p class="kod__number" id="asd" @click="copy('asd')">{{ bookingInfo.number }}</p>
					<div class="alert" :class="{ alertActive: alertActive === true }">
						<h1>{{ $t("copied") }}!</h1>
					</div>
				</div>
				<h2>{{ $t("textClick") }}</h2>
				<p>{{ $t("textPlease") }}</p>
				<h3>{{ $t("textWe") }}</h3>
			</div>
		</div>

		<div v-show="alertError" class="alertError">
			<p class="alertError__title">{{ $t("textAlready") }}</p>
			<a @click.prevent="closeAlertError()" href="" class="alertError__link">{{ $t("close") }}</a>
		</div>
		<div v-show="alertError" class="alertErrorBg"></div>

		<Loading v-show="loading" />
	</div>
</template>

<script>
import Loading from "@/components/Loading.vue"
import Datepicker from "vuejs-datepicker"
import { en, ru, uz } from 'vuejs-datepicker/dist/locale'
import axios from "axios"
import moment from "moment"
import "moment/locale/uz-latn"
import { maxLength, minLength, required } from "vuelidate/lib/validators"

export default {
	data() {
		return {
			en: en, ru: ru, uz: uz,
			authStep: 1,
			otpCode: "",
			disabledDates: {
				to: new Date(Date.now() - 8640000),
				days: [6, 0],
				dates: []
			},
			liActive: "", liTimeActive: "",
			isActive: false, isTimeActive: false,
			cardModal: false, cardModalEnd: false, cardModalBg: false,
			alertActive: false, alertError: false,
			bookingInfo: {
				name: "", surname: "", email: "test@test.uz", phone: "+998",
				serviseText: "", time: "", number: "",
				date: { day: "", month: "", year: "" },
				clientId: ''
			},
			date: "", filial: [], items: [], booking: [], timeAll: [],
			loading: false, serviceId: 0, startDate: '',
			apiBookingBarakaTexnika: "",
			isInputActiveDate: true, isInputActiveTime: true,
			linkImg: '', settings: {},
		}
	},
	components: { Datepicker, Loading },
	validations: {
		bookingInfo: {
			name: { required, minLength: minLength(2) },
			surname: { required, minLength: minLength(2) },
			phone: { required, minLength: minLength(13), maxLength: maxLength(13) },
			serviseText: { required, minLength: minLength(4) },
			time: { required, minLength: minLength(4) },
		},
		date: { required },
	},
	mounted() {
		this.loading = true
		this.settings = window.MY_CONFIG_EASYQ
		this.loadFilial()
		this.loadService()
		this.startDate = moment().format('YYYYMMDD')
		this.linkImg = this.settings.linkImg
	},
	methods: {
		customFormatter(date) {
			return moment(date).locale(this.$t("local")).format("MMMM DD, YYYY")
		},
		// Управление шагами формы
		handleSubmit() {
			if (this.authStep === 1) {
				this.requestSmsCode();
			} else {
				this.verifyAndLogin();
			}
		},
		// Шаг 1: Запрос SMS кода
		async requestSmsCode() {
			this.$v.$touch();
			if (this.$v.$invalid) return;

			this.loading = true;
			try {
				const response = await axios.post(`${this.settings.apiBookingBarakaTexnika}/Bookings/auth/request-code`,
					JSON.stringify(this.bookingInfo.phone),
					{ headers: { 'Content-Type': 'application/json' } }
				);
				if (response.data.success) {
					this.authStep = 2;
				}
			} catch (e) {
				alert(this.$t("smsError") || "Ошибка при отправке SMS");
			} finally {
				this.loading = false;
			}
		},
		// Шаг 2: Проверка кода и открытие модалки подтверждения
		async verifyAndLogin() {
			if (this.otpCode.length < 4) return;
			this.loading = true;
			try {
				const response = await axios.post(`${this.settings.apiBookingBarakaTexnika}/Bookings/auth/login`, {
					PhoneNumber: this.bookingInfo.phone,
					Code: this.otpCode
				});

				if (response.data.token) {
					localStorage.setItem('user_token', response.data.token);
					this.bookingInfo.date.day = moment(this.date).locale(this.$t("local")).format("DD")
					this.bookingInfo.date.month = moment(this.date).locale(this.$t("local")).format("MMMM")
					this.bookingInfo.date.year = moment(this.date).locale(this.$t("local")).format("YYYY")
					this.cardModal = true;
					this.cardModalBg = true;
				}
			} catch (e) {
				alert(this.$t("authError") || "Неверный код");
			} finally {
				this.loading = false;
			}
		},
		// Финальная отправка бронирования
		send() {
			this.cardModal = false
			this.loading = true

			const bookingData = {
				"BranchId": parseInt(this.$route.params.id),
				"Email": this.bookingInfo.email,
				"FirstName": this.bookingInfo.name,
				"LastName": this.bookingInfo.surname,
				"LanguageShortId": this.$route.params.lang,
				"PhoneNumber": this.bookingInfo.phone,
				"ServiceId": this.serviceId,
				"StartDate": moment(this.date).format("YYYY-MM-DDTHH:mm:ss.sss[Z]"),
				"StartTime": this.bookingInfo.time
			}

			const endpoint = `${this.settings.apiBookingBarakaTexnika}/Bookings/CreateBooking`

			axios.post(endpoint, bookingData)
				.then((response) => {
					const info = response.data
					if (info.BookingCode || info.bookingCode) {
						this.bookingInfo.number = info.BookingCode || info.bookingCode
						this.loading = false
						this.cardModalEnd = true
						this.saveToLocalStorage(info);
					} else {
						this.loading = false
						this.alertError = true
					}
				})
				.catch(() => {
					this.loading = false
					this.alertError = true
				})
		},
		saveToLocalStorage(info) {
			const entry = {
				name: this.bookingInfo.name,
				surname: this.bookingInfo.surname,
				phone: this.bookingInfo.phone,
				day: this.bookingInfo.date.day,
				month: this.bookingInfo.date.month,
				year: this.bookingInfo.date.year,
				time: this.bookingInfo.time,
				branch: this.filial.BranchName,
				branchId: this.$route.params.id,
				address: this.filial.BranchAddress,
				serviseText: this.bookingInfo.serviseText,
				number: info.BookingCode || info.bookingCode,
				startDate: moment(this.date).format("YYYY-MM-DD"),
				clientId: info.ClientId || info.clientId
			}
			let bookings = JSON.parse(localStorage.getItem("booking") || "[]")
			bookings.push(entry)
			localStorage.setItem("booking", JSON.stringify(bookings))
		},
		// Методы UI (оригинальные)
		openService() { this.isActive = true },
		openTime() { this.isTimeActive = true },
		closeService() { this.isActive = false },
		closeTime() { this.isTimeActive = false },
		showService() {
			if (this.liActive !== "") {
				this.bookingInfo.serviseText = this.items.find(i => i.ServiceId === this.liActive).ServiceName;
			}
			this.isActive = false;
		},
		liServiceActiveLink(id) {
			this.serviceId = id;
			this.liActive = id;
		},
		showTime() {
			if (this.liTimeActive !== "") {
				this.bookingInfo.time = this.liTimeActive;
			}
			this.isTimeActive = false;
		},
		liTimeActiveLink(params) {
			if (params.IsAvailableTime == true) {
				this.liTimeActive = params.Time;
			}
		},
		close() { this.cardModal = false; this.cardModalBg = false; },
		closeAlertError() { this.alertError = false; this.$router.push({ name: "Home" }); },
		closeEnd() { this.cardModalBg = false; this.cardModalEnd = false; this.$router.push({ name: "Profil" }); },
		copy(text) {
			var id = document.getElementById(text).innerText
			var elem = document.createElement("textarea")
			document.body.appendChild(elem); elem.value = id; elem.select();
			document.execCommand("copy"); document.body.removeChild(elem)
			this.alertActive = true; setTimeout(() => (this.alertActive = false), 2000)
		},
		// Загрузка данных (оригинальные методы)
		async loadService() {
			const url = `${this.settings.apiBookingBarakaTexnika}/ListServices?BranchId=${this.$route.params.id}&languageShortId=${this.$route.params.lang}`
			axios.get(url).then(res => { this.items = res.data; this.loading = false; })
		},
		async loadFilial() {
			const url = `${this.settings.apiBookingBarakaTexnika}/Branches/ListBranches`
			axios.get(url).then(res => {
				this.filial = res.data.find(el => el.BranchId === +this.$route.params.id)
			})
		},
		loadDate() {
			const url = `${this.settings.apiBookingBarakaTexnika}/ListFreeDaysMonth?branchId=${this.$route.params.id}&serviceId=${this.serviceId}&startDate=${moment(this.startDate).format("YYYY-MM-DD")}`
			axios.get(url).then(res => {
				res.data.forEach(d => { if (d.FreePlacesCount == 0) this.disabledDates.dates.push(new Date(d.Year, d.Month - 1, d.Day)) })
			})
		},
		loadTimes() {
			this.timeAll = []; this.loading = true
			const url = `${this.settings.apiBookingBarakaTexnika}/ListFreeTimes?branchId=${this.$route.params.id}&serviceId=${this.serviceId}&startDate=${moment(this.date).format("YYYY-MM-DD")}`
			axios.get(url).then(res => {
				this.timeAll = res.data.filter(t => t.FreePlacesCount != 0)
				this.loading = false
			})
		}
	},
	created() { this.$i18n.locale = this.$route.params.lang },
	watch: {
		date() { if (this.date != '') { this.loadTimes(); this.isInputActiveTime = false; } this.bookingInfo.time = ''; },
		serviceId() { this.loadDate(); this.isInputActiveDate = false; this.date = ''; },
		'$route.params.lang'() { this.$i18n.locale = this.$route.params.lang; this.loadService(); }
	}
}
</script>

<style>
.is-invalid {
	border-color: red !important;
}

.inputBlock {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	z-index: 1;
}

.posRel {
	position: relative;
}
</style>